import {css} from 'lit';
export const styles = css`:host {
  --slide-height: 200px;
  --pagination-height: 8px;
  --pagination-margin: 8px;

  position: relative;
  display: block;
}

  :host > span {
    position: absolute;
    top: 16px;
    right: 16px;
    padding: 4px 8px;
    background-color: var(--contrast-dark);
    color: var(--light-text);
    border-radius: 20px;
    font-size: var(--font-size-sm);
    z-index: 10;
  }

  :host ion-slides {
    --bullet-background: var(--gray-700);
    --bullet-background-active: var(--primary);

    height: calc(
      var(--slide-height) + var(--pagination-height) + var(--pagination-margin)
    );
    padding-bottom: calc(var(--pagination-height) + var(--pagination-margin));
  }

  :host .swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover;
  }

  :host .swiper-pagination {
    bottom: 0;
    height: var(--pagination-height);
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
export default styles;
